import Lottie from 'lottie-react';

import faceTalkingExcited from '../jsons/Face_Talking_Excited.json';

const FaceTalkingExcited = props => {
  return <Lottie animationData={faceTalkingExcited} {...props} />;
};

export default FaceTalkingExcited;
